import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const SolutionsNavigation = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Show when scrolling up or at the top
      if (currentScrollY < lastScrollY || currentScrollY < 100) {
        setIsVisible(true);
      } else if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // Hide when scrolling down past 100px
        setIsVisible(false);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return (
    <div
      className={`fixed top-20 left-0 right-0 z-40 transition-all duration-300 flex justify-center px-2 sm:px-4 md:px-0 ${
        isVisible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'
      }`}
    >
      <div
        className="flex items-center gap-2 sm:gap-4 md:gap-8 lg:gap-10 px-3 sm:px-5 md:px-10 lg:px-14 py-2 sm:py-3 md:py-4 rounded-full backdrop-blur-lg"
        style={{
          background: 'linear-gradient(135deg, rgba(6, 182, 212, 0.85) 0%, rgba(59, 130, 246, 0.85) 100%)',
          border: '1px solid rgba(6, 182, 212, 0.6)'
        }}
      >
            <Link
              to="/products/deepflow"
              className="text-white font-medium sm:font-semibold hover:text-gray-100 transition-colors text-[10px] sm:text-xs md:text-base lg:text-lg whitespace-nowrap"
            >
              <span className="md:hidden">DeepFlow</span>
              <span className="hidden md:inline">DeepFlow AI</span>
            </Link>
            <Link
              to="/products/niyukti"
              className="text-white font-medium sm:font-semibold hover:text-gray-100 transition-colors text-[10px] sm:text-xs md:text-base lg:text-lg whitespace-nowrap"
            >
              <span className="md:hidden">Niyukti</span>
              <span className="hidden md:inline">Niyukti AI</span>
            </Link>
            <Link
              to="/products/lendsmart"
              className="text-white font-medium sm:font-semibold hover:text-gray-100 transition-colors text-[10px] sm:text-xs md:text-base lg:text-lg whitespace-nowrap"
            >
              <span className="md:hidden">LendSmart</span>
              <span className="hidden md:inline">LendSmart AI</span>
            </Link>
            <Link
              to="/products/tenderlens"
              className="text-white font-medium sm:font-semibold hover:text-gray-100 transition-colors text-[10px] sm:text-xs md:text-base lg:text-lg whitespace-nowrap"
            >
              <span className="md:hidden">TenderLens</span>
              <span className="hidden md:inline">TenderLens AI</span>
            </Link>
            <Link
              to="/products/qsm"
              className="text-white font-medium sm:font-semibold hover:text-gray-100 transition-colors text-[10px] sm:text-xs md:text-base lg:text-lg whitespace-nowrap"
            >
              <span className="md:hidden">PQC</span>
              <span className="hidden md:inline">PQC Migration</span>
            </Link>
      </div>
    </div>
  );
};

export default SolutionsNavigation;
